module.exports = __webpack_public_path__ + "9370f93a4ae7954305ac4cb55806d62a.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-4/carters.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-4/carters.jpg
// module chunks = 40